import { locales } from '@innovyze/stylovyze';
import stylovyzeI18nSettings from '@innovyze/stylovyze/translations/Translations.json';
import adminI18nSettings from './settings.json';
import { getTranslationFile } from '@innovyze/lib_asset_schema';

export const globalization = {
	bundles: [
		...locales.map(locale => ({
			language: locale,
			namespace: adminI18nSettings.ns,
			file: import(`../../data/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: stylovyzeI18nSettings.ns,
			file: import(`@innovyze/stylovyze/translations/${locale}.json`),
		})),
		...locales.map(locale => ({
			language: locale,
			namespace: 'lib-asset-schema',
			file: getTranslationFile(locale),
		})),
	],
};
